if (process.env.REACT_APP_ANALYTICS_ENV === 'production') {
  module.exports = require('./root.container.prod');
} else if (process.env.REACT_APP_ANALYTICS_ENV === 'stage') {
  module.exports = require('./root.container.stage');
} else {
  module.exports = require('./root.container.dev');
}